import { getLineDatasetsFromPoints } from "../../../../services/entity/chart/chart-service";
import { Line } from "react-chartjs-2";


export const BlockLineChart = ({ chartData }) => {

  const dataset = getLineDatasetsFromPoints(chartData, 2);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: 'time',
        position: 'bottom',
        offset: false,
        grid: {
          display: true,
        },
        time: {
          unit: 'day',
          displayFormats: { hour: 'MMM D, YYYY HH:mm', minute: 'HH:mm' },
        },
      },
      y: {
        min: 0,
        // max: max,
        beginAtZero: true,
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 20,
        },
      },
    },
  };

  return (
    <div className="relative w-full h-full">
      <Line data={{ datasets: [dataset] }} options={options} />
    </div>
  );
};